/**
 * MyBricks Opensource
 * https://mybricks.world
 * This source code is licensed under the MIT license.
 *
 * CheMingjun @2019
 * mybricks@126.com
 */
import { validateEntity } from '../_utils/validate';
export default {
    /** 环境发生变化 */
    '@envChanged': function (_a) {
        var data = _a.data, env = _a.env, cancelError = _a.cancelError, throwError = _a.throwError;
        if (!data.rules) {
            return;
        }
        var error = validateEntity(data.rules.entities, env.entity);
        error ? throwError(error) : cancelError();
        data.errorMessage = error;
    },
    ':root': [
        {
            title: '编辑',
            type: 'domain.dbInsert',
            options: function (_a) {
                var data = _a.data, input = _a.input;
                return {
                    get paramSchema() {
                        return input.get('params').schema || {};
                    },
                    get errorMessage() {
                        return data.errorMessage;
                    },
                    batch: true,
                };
            },
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.rules;
                },
                set: function (_a, val) {
                    var data = _a.data, setDesc = _a.setDesc, cancelError = _a.cancelError;
                    data.rules = val;
                    data.errorMessage = '';
                    cancelError();
                    if (data.rules) {
                        setDesc("\u5DF2\u9009\u62E9 ".concat(data.rules.desc));
                    }
                    else {
                        setDesc('未完成选择');
                    }
                }
            }
        }
    ]
};
